export default __webpack_public_path__ + "static/media/overview-bg.424a2af8.png";